module.exports = __webpack_public_path__ + "img/dirty_floor.97cd53ff.svg";